import React from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { PatchedPatchEmployee } from '../../../../store/generated/portal/employee/employees';

interface DemographicField {
  name: string;
  displayName: string;
  required: boolean;
  custom?: boolean;
  type?: string;
  validValues?: { key: string; text: string }[];
  source?: string;
  priority?: string;
}

interface MemberCategoriesTabProps {
  formData: PatchedPatchEmployee;
  demographicFields: DemographicField[];
  onDropdownChange: (e: React.SyntheticEvent, data: any) => void;
}

const MemberCategoriesTab: React.FC<MemberCategoriesTabProps> = ({
  formData,
  demographicFields,
  onDropdownChange,
}) => {

  if (!demographicFields || !Array.isArray(demographicFields)) {
    return (
      <Form>
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          Loading demographic fields...
        </div>
      </Form>
    );
  }

  const buildOptions = (
    field: DemographicField,
    fieldValue: string | number | null | undefined
  ) => {
    const base =
      Array.isArray(field.validValues) && field.validValues.length
        ? field.validValues.map(v => {
          // support {key,text} or {key,value}
          const text = (v as any).text ?? (v as any).value ?? "";
          const key = (v as any).key ?? text;
          return { key, value: text, text };
        })
        : [];

    // ensure current value is selectable
    const val = fieldValue ?? "";
    if (val && !base.some(o => o.value === val)) {
      base.unshift({ key: String(val), value: String(val), text: String(val) });
    }

    // add a blank option at the top
    return [{ key: "__blank__", value: "", text: "-" }, ...base];
  };


  // Filter to show only non-custom demographic fields (survey structure fields)
  const surveyStructureFields = demographicFields.filter(field => field && !field.custom);

  return (
    <Form>
      {surveyStructureFields.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          No demographic fields configured for this organization.
        </div>
      ) : (
        surveyStructureFields
          .map(field => {
            // Add defensive programming for field properties
            if (!field || !field.name || !field.displayName) {
              return null; // Skip invalid fields
            }

            const fieldKey = field.name;
            const fieldValue = (formData as any)[field.name] || '';
            const displayName = field.displayName || field.name;

            return (
              <Form.Group key={field.name} widths="equal" inline>
                <label style={{ minWidth: '170px' }}>{displayName}</label>
                <Form.Field style={{ flex: 1 }}>
                  <Dropdown
                    name={fieldKey}
                    placeholder={`Select ${displayName.toLowerCase()}`}
                    fluid
                    selection
                    clearable
                    search
                    value={fieldValue ?? ""}
                    options={buildOptions(field, fieldValue)}
                    onChange={onDropdownChange}
                    error={field.required && !fieldValue}
                  />
                </Form.Field>
              </Form.Group>

            );
          })
          .filter(Boolean) // Remove null entries
      )}
    </Form>
  );
};

export default MemberCategoriesTab;
